/**
 * possible status values
 */
export enum PollingStatus {
    Unknown = 'unknown',
    Timeout = 'timeout',
    Running = 'running',
    Updated = 'updated',
    Finished = 'finished',
    Error = 'error',
    AllError = 'all-error',
}

/**
 * known polling event types
 */
export enum PollingEventType {
    HotelList = 'hds_hotel_list',
    OfferList = 'offer_list',
    FilterInformation = 'filter_information',
    Vacancy = 'vacancy',
    KiFilter = 'ki_filter',
}

/**
 * known polling steps
 */
export enum PollingStep {
    HotelList = 'hotelList',
    OfferList = 'offerList',
}

/**
 * interface representing poll event response data type
 */
export interface PollingEvent {
    type: PollingEventType;
    status: PollingStatus;
    total: number;
    finished: number;
}

/**
 * interface representing polling response data
 */
export interface PollingData {
    events?: PollingEvent[];
    status: PollingStatus;
}

/**
 * interface representing polling response
 */
export interface PollingResponse {
    data: PollingData;
}

/**
 * interface representing polling request
 */
export interface PollingRequest {
    clientId: string;
    step?: PollingStep;
}

/**
 * interface for single poll event configuration node
 */
export interface EventConfigDefinition {
    onPollError?: (updatePending: boolean) => void;
    onTimeout?: (updatePending: boolean) => void;
    onPollUpdate?: (event: PollingEvent) => void;
    onPollFinished?: (event: PollingEvent) => void;
    updateInterval?: number;
    timeout?: number;
}

/**
 * type for poll event config
 */
export type EventConfig = Partial<
    Record<PollingEventType, EventConfigDefinition>
>;

/**
 * definition of polling states being considered as pending
 */
export const PENDING_STATES = new Set([
    PollingStatus.Updated,
    PollingStatus.Running,
]);

/**
 * wrapping interface for passing poll event data and additional info
 */
export interface PollEventData {
    event: PollingEvent;
    updateCount: number;
    updatePending: boolean;
}

/**
 * type for previous event data storage
 */
export type PreviousEventDataMap = Map<PollingEventType, PollEventData>;

/**
 * interface holding relevant polling state data
 */
export interface PollingState {
    started: number;
    previousEventData: PreviousEventDataMap;
}
